import { ArrowSmallLeftIcon } from '@heroicons/react/20/solid';
import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Entity } from '../../../../types/entity';
import Chart from './Chart';

type ChartContainerProps = {
    id: string;
    entity: Entity;
};

function ChartContainer({ id, entity }: ChartContainerProps): JSX.Element {
    const [search] = useSearchParams();

    useEffect(() => {
        search.delete('chart');
    }, [search]);

    return (
        <div>
            <div className="flex-1 mb-2">
                <Link to={`${location.pathname}?${search.toString()}`} className="flex items-center text-sm text-gray-500 w-fit">
                    <ArrowSmallLeftIcon className="h-5 w-5 mr-2" /> Back to Charts
                </Link>
            </div>
            <Chart id={id} entity={entity} />
        </div>
    );
}

export default ChartContainer;
